import React, { useState } from 'react';
import { supabase } from '../../supabaseClient';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const { error } = await supabase.auth.signInWithPassword({
      email: username,
      password,
    });

    if (error) {
      setError(error.message);
      setLoading(false);
    } else {
      navigate('/admin/dashboard');
    }
  };

  return (
    <div className="min-h-screen bg-cover bg-center" style={{ backgroundImage: "url('/assets/images/section-img/section_intro_ourTeam.jpg')" }}>
      <div className="min-h-screen flex text-white bg-[#28357B]/50 lg:bg-gradient-to-r lg:from-[#28357B] lg:from-30% lg:via-[#28357B]/80 lg:via-65% lg:to-transparent backdrop-blur-sm lg:backdrop-blur-sm">
        {/* Left: Content & Form */}
        <div className="w-full lg:w-1/2 flex items-center justify-center">
          <div className="w-full max-w-xl bg-[#28357B]/70 lg:bg-transparent backdrop-blur-md lg:backdrop-blur-none px-8 lg:px-18 py-10 mx-4 rounded-xl">
            {/* Brand */}
            <div className="flex items-center space-x-2 mb-8">
              <img src="/assets/images/logo/semesta-logo.png" alt="logo" className="w-10 h-10" />
              <span className="text-md font-semibold text-gray-300">SEMESTA</span>
            </div>

            {/* Heading */}
            <h1 className="text-4xl lg:text-5xl font-extrabold tracking-tight">
              Hi, welcome back <br className="hidden sm:block" /> Admin SEMESTA
              <span className="inline-block align-middle w-2 h-2 rounded-full bg-[#FDA729] ml-1"></span>
            </h1>

            {/* Form */}
            <form className="mt-10 space-y-5" onSubmit={handleLogin} autoComplete="off">
              {error && (
                <div className="text-yellow-200 bg-yellow-500/10 border border-yellow-400/40 rounded-md p-2 text-sm">
                  {error}
                </div>
              )}

              <div>
                <label className="block text-sm font-medium mb-2 text-gray-300">
                  Email <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  autoComplete="username"
                  required
                  placeholder="Enter email"
                  className="w-full px-4 py-2.5 bg-white/10 border border-white/20 rounded-lg text-white placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2 text-gray-300">
                  Password <span className="text-red-500">*</span>
                </label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                  required
                  placeholder="Enter password"
                  className="w-full px-4 py-2.5 bg-white/10 border border-white/20 rounded-lg text-white placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:border-transparent"
                />
              </div>

              <button
                type="submit"
                className="w-full px-6 py-2.5 rounded-lg bg-[#FDA729] text-[#0B1215] font-semibold shadow hover:bg-[#FDA729]/80 transition disabled:opacity-50"
                disabled={loading}
              >
                {loading ? 'Logging in...' : 'Log in'}
              </button>
            </form>
          </div>
        </div>

        {/* Right: Illustration & Ambient */}
        <div className="hidden lg:block lg:w-1/2 relative overflow-hidden">
          {/* Ambient curved lines */}
          {/* <img src="/assets/images/header-bg/bg_quotes.jpg" alt="Ambient" className="absolute inset-0 h-full w-full object-cover" /> */}

          {/* Placeholder for logo bottom-right */}
          <div className="absolute bottom-8 right-8 text-white/40 font-black tracking-widest">
            SEMESTA
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;